// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // Vacío: el browser pega a localhost y `proxy.conf.js` reenvía a QA (evita CORS).
  // apiUrl: 'http://local.agendate:3000',
  // apiUrl: 'https://qa.agendateapp.com',
  apiUrl: '',
  APIMAIN: '/agendate.main.ms',
  APIVDSAGENDA: '/vds.agenda.ms',
  // serverSocket: 'http://local.agendate:3000',
  // serverSocket: 'https://qa.agendateapp.com',
  serverSocket: '',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
